import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
  Grid,
} from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { LANGUAGES, ACCESSIBILITY_FEATURES } from '../types/property';

export function PoliciesSection({ formData, onChange }) {
  const toggleLanguage = (language) => {
    const currentLanguages = formData.languages || [];
    const updatedLanguages = currentLanguages.includes(language)
      ? currentLanguages.filter((l) => l !== language)
      : [...currentLanguages, language];
    onChange('languages', updatedLanguages);
  };

  const toggleAccessibility = (feature) => {
    const currentFeatures = formData.accessibility || [];
    const updatedFeatures = currentFeatures.includes(feature)
      ? currentFeatures.filter((f) => f !== feature)
      : [...currentFeatures, feature];
    onChange('accessibility', updatedFeatures);
  };

  return (
    <Box sx={{ my: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <VerifiedUserIcon color="primary" />
        <Typography variant="h6" fontWeight={700}>
          Policies & Additional Information
        </Typography>
      </Box>

      <Box sx={{ mb: 3 }}>
        <TextField
          fullWidth
          multiline
          minRows={4}
          label="Cancellation Policy *"
          id="cancellationPolicy"
          value={formData.policies.cancellation|| ''}
          onChange={(e) => {
  onChange('policies', {...formData.policies, cancellation: e.target.value});
}}
          placeholder="Describe your cancellation policy, refund terms, etc."
          sx={{ mb: 3 }}
        />

        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel id="pet-policy-label">Pet Policy</InputLabel>
              <Select
                labelId="pet-policy-label"
                id="petPolicy"
                value={formData.policies?.petPolicy || 'not-allowed'}
                label="Pet Policy"
                 onChange={(e) => {
  onChange('policies', {...formData.policies, petPolicy: e.target.value});
}}
    
              >
                <MenuItem value="allowed">Pets Allowed</MenuItem>
                <MenuItem value="not-allowed">Pets Not Allowed</MenuItem>
                <MenuItem value="on-request">On Request</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel id="smoking-policy-label">Smoking Policy</InputLabel>
              <Select
                labelId="smoking-policy-label"
                id="smokingPolicy"
                value={formData.policies?.smokingPolicy || 'not-allowed'}
                label="Smoking Policy"
                onChange={(e) => {
  onChange('policies', {...formData.policies, smokingPolicy: e.target.value});
}}
    
              >
                <MenuItem value="allowed">Smoking Allowed</MenuItem>
                <MenuItem value="not-allowed">No Smoking</MenuItem>
                <MenuItem value="designated-areas">Designated Areas</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel id="currency-label">Currency</InputLabel>
              <Select
                labelId="currency-label"
                id="currency"
                value={formData.policies?.currency || 'INR'}
                label="Currency"
                 onChange={(e) => {
  onChange('policies', {...formData.policies, currency: e.target.value});
}}
    
              >
                <MenuItem value="INR">₹ INR</MenuItem>
                <MenuItem value="USD">$ USD</MenuItem>
                <MenuItem value="EUR">€ EUR</MenuItem>
                <MenuItem value="GBP">£ GBP</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <TextField
          fullWidth
          multiline
          minRows={3}
          label="Child Policy"
          id="childPolicy"
          value={formData.policies?.childPolicy || ''}
           onChange={(e) => {
  onChange('policies', {...formData.policies, childPolicy: e.target.value});
}}
    
          placeholder="Describe policies for children (age limits, extra charges, etc.)"
          sx={{ mb: 3 }}
        />

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" gutterBottom>
            Languages Spoken
          </Typography>
          <Grid container spacing={2}>
            {LANGUAGES.map((language) => (
              <Grid item xs={6} md={3} key={language}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.languages?.includes(language) || false}
                      onChange={() => toggleLanguage(language)}
                      id={`language-${language}`}
                    />
                  }
                  label={language}
                />
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" gutterBottom>
            Accessibility Features
          </Typography>
          <Grid container spacing={2}>
            {ACCESSIBILITY_FEATURES.map((feature) => (
              <Grid item xs={6} md={4} key={feature}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.accessibility?.includes(feature) || false}
                      onChange={() => toggleAccessibility(feature)}
                      id={`accessibility-${feature}`}
                    />
                  }
                  label={feature}
                />
              </Grid>
            ))}
          </Grid>
        </Box>

        <TextField
          fullWidth
          multiline
          minRows={3}
          label="Special Features"
          id="specialFeatures"
          value={formData.specialFeatures || ''}
          onChange={(e) => onChange('specialFeatures', e.target.value)}
          placeholder="Highlight any unique features (heritage property, eco-friendly, organic farming, etc.)"
          sx={{ mb: 3 }}
        />

        <TextField
          fullWidth
          multiline
          minRows={3}
          label="Nearby Attractions"
          id="nearbyAttractions"
          value={formData.nearbyAttractions || ''}
          onChange={(e) => onChange('nearbyAttractions', e.target.value)}
          placeholder="List nearby tourist attractions, distances, etc."
        />
      </Box>
    </Box>
  );
}
